// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let V4 = require("uuid/v4");
let Stdlib_List = require("@rescript/runtime/lib/js/Stdlib_List.js");
let JsxRuntime = require("react/jsx-runtime");

function make(id, type_, text, time, renderButtons, dismissableOpt) {
  let dismissable = dismissableOpt !== undefined ? dismissableOpt : true;
  return {
    id: id !== undefined ? id : V4(),
    type_: type_,
    text: text,
    time: time,
    renderButtons: renderButtons,
    dismissable: dismissable
  };
}

let Message = {
  make: make
};

function defaultValue_addMessage(param) {
  
}

function defaultValue_removeMessage(param) {
  
}

let defaultValue = {
  addMessage: defaultValue_addMessage,
  removeMessage: defaultValue_removeMessage,
  messages: /* [] */0
};

let systemMessagesContext = React.createContext(defaultValue);

let make$1 = systemMessagesContext.Provider;

let Provider = {
  make: make$1
};

function SystemMessages$Provider(props) {
  let match = React.useState(() => /* [] */0);
  let setMessages = match[1];
  let addMessage = React.useCallback(message => setMessages(state => Stdlib_List.add(state, message)), [setMessages]);
  let removeMessage = React.useCallback(id => setMessages(state => Stdlib_List.filter(state, x => x.id !== id)), [setMessages]);
  let value_messages = match[0];
  let value = {
    addMessage: addMessage,
    removeMessage: removeMessage,
    messages: value_messages
  };
  return JsxRuntime.jsx(make$1, {
    value: value,
    children: props.children
  });
}

let Provider$1 = {
  Provider: Provider,
  make: SystemMessages$Provider
};

function useSystemMessages() {
  return React.useContext(systemMessagesContext);
}

let providerJs = SystemMessages$Provider;

exports.Message = Message;
exports.defaultValue = defaultValue;
exports.systemMessagesContext = systemMessagesContext;
exports.Provider = Provider$1;
exports.providerJs = providerJs;
exports.useSystemMessages = useSystemMessages;
/* systemMessagesContext Not a pure module */
